import type { LocaleCode } from '@@fire-base/i18n'
import type { JSONString } from '@@fire-base/types/utils/JSONString'

export type ShopConfiguration = {
  id: number
  shopConfigurationId: number
  name: string
  loginWithCustomerNo: boolean
  loginAcceptTos: boolean
  loginUsernameLabel: string
  // FIXME(corsin): according to spec, these fields should be present here.
  // As a temporary workaround, they are included in b2bConfiguration as JSON.
  // useSsoSaml: boolean
  // useSsoGoogle: boolean
  registerForm: boolean
  copyright: string
  termsOfService: string
  imprint: string
  privacyPolicy: string
  b2bConfiguration: JSONString // JSON string representation of ShopConfigurationB2B
  logos: {
    id: number
    targetAttr: string
    path: string
    mime: string
    alt: string
  }[]
  loginLogos: {
    id: number
    targetAttr: string
    path: string
    mime: string
    alt: string
  }[]
  loginImages: {
    id: number
    targetAttr: string
    thumbnail: string
    mime: string
    alt: string
  }[]
}

export type ShopConfigurationB2B = {
  selfServiceName: string
  hideFireBranding: boolean
  confirmToS: boolean
  // FIXME(corsin): useSsoSaml and useSsoGoogle should be in ShopConfiguration interface according to spec.
  // Here as a temporary workaround.
  useSsoSaml: boolean
  useSsoGoogle: boolean
  catalog: ShopConfigurationB2BCatalog
  orderHistory: ShopConfigurationB2BOrderHistory
  accountNavigation: ShopConfigurationB2BAccountNavigation
  favicon: ShopConfigurationB2BFavicon
  general: ShopConfigurationB2BGeneral
}

export type ShopConfigurationB2BCatalog = {
  itemsPerPage: number
}

export type ShopConfigurationB2BOrderHistory = {
  /**
   * Defines how many months back the orders are displayed. It is always
   * rounded down to the beginning of a month.
   * If not set (undefined), all orders are displayed.
   */
  cutOffTime: number | undefined
}

export type ShopConfigurationB2BAccountNavigation = {
  showProfile: boolean
  showOpenOrders: boolean
  showOrderHistory: boolean
  showWishlist: boolean
  showDocuments: boolean
  showAddresses: boolean
  showContracts: boolean
  showUsers: boolean
}

export type ShopConfigurationB2BGeneral = {
  languages: LocaleCode[]
  gqlLocaleFallback: Partial<Record<LocaleCode, LocaleCode>>
}

export type ShopConfigurationB2BFavicon = {
  'ico': string
  'svg': string
  'apple-touch': string
  '192-png': string
  '512-png': string
  'mask-png': string
}

export const DEFAULT_SHOP_CONFIGURATION_B2B: ShopConfigurationB2B = {
  selfServiceName: 'Self-Service Portal',
  hideFireBranding: false,
  confirmToS: false,
  useSsoSaml: false,
  useSsoGoogle: false,
  catalog: {
    itemsPerPage: 24,
  },
  orderHistory: {
    cutOffTime: undefined,
  },
  accountNavigation: {
    showProfile: false,
    showOpenOrders: false,
    showOrderHistory: false,
    showWishlist: false,
    showDocuments: false,
    showAddresses: false,
    showContracts: false,
    showUsers: false,
  },
  favicon: {
    'ico': '',
    'svg': '',
    'apple-touch': '',
    '192-png': '',
    '512-png': '',
    'mask-png': '',
  },
  general: {
    languages: ['en'],
    gqlLocaleFallback: {},
  },
}
